module.exports = __webpack_public_path__ + "56e3120247f5f5217fef3f81a7a873e0.pdf";